module.exports = __webpack_public_path__ + "static/media/tone1_bad.5e422b88.svg";